export default {
	title: "监测",
	url: "watch",
	subtitle: "通过匿名化研究生成的战略监测报告：在查询任何公开来源之前，项目主题会被中立化处理。报告涵盖宏观环境（PESTEL）、行业环境（波特五力）和内部环境，并区分强信号与弱信号。",
	current: "当前报告",
	archive: "存档",
	context_tab: "背景",
	empty: "该项目暂无监测报告。",
	generated_on: "生成于",
	actions: {
		generate: "生成报告",
		generate_new: "生成新报告",
		generating: "生成中…（大约需要十分钟）",
		retry: "重试",
		print: "打印",
		delete: "删除此报告",
		delete_confirm: "永久删除此报告？"
	},
	steps: {
		anonymizing: "主题匿名化",
		researching: "研究与撰写",
		done: "报告可用",
		elapsed: "已进行{{minutes}}分钟"
	},
	messages: {
		failed: "生成失败",
		neutral_subject: "已发送的匿名化主题",
		confirm_title: "启动匿名化监测？",
		confirm_body: "在对公开来源进行任何研究之前，项目主题将被匿名化处理。报告生成大约需要十分钟。"
	}
};
